interface IconNotFoundProps {
  className?: string
}
export const IconNotFound = ({ className }: IconNotFoundProps) => {
  return (
    <svg
      className={className}
      width='122'
      height='122'
      viewBox='0 0 122 122'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_28268_102637)'>
        <path
          d='M76.239 41.8306L47.9595 52.0762L36.1172 11.8897L63.6344 2.07812L76.239 41.8306Z'
          fill='#FF4B32'
        />
        <path
          d='M42.5709 9.58984L36.1172 11.8909L47.9595 52.0774L54.4031 49.743L42.5709 9.58984Z'
          fill='#FF0000'
        />
        <path
          d='M101.907 47.5081L73.6272 57.7537L61.7852 17.5672L90.0649 10.1602L101.907 47.5081Z'
          fill='#4DABF5'
        />
        <path
          d='M68.1638 15.8984L61.7852 17.5692L73.6272 57.7556L79.8354 55.5065L68.1638 15.8984Z'
          fill='#4791DB'
        />
        <path
          d='M105.3 86.9804H39.4549L26.043 29.1328L106.183 41.6352C108.959 42.0682 111.004 44.448 111.004 47.2443V81.3029C111.004 84.4384 108.45 86.9804 105.3 86.9804Z'
          fill='#EEEEEE'
        />
        <path
          d='M37.6406 79.1602L39.4539 86.9809H105.299C108.449 86.9809 111.003 84.439 111.003 81.3032V79.1602H37.6406Z'
          fill='#E5E5E5'
        />
        <path
          d='M91.9935 119.911C96.0738 119.911 99.3815 116.642 99.3815 112.61C99.3815 108.577 96.0738 105.309 91.9935 105.309C87.9132 105.309 84.6055 108.577 84.6055 112.61C84.6055 116.642 87.9132 119.911 91.9935 119.911Z'
          fill='#F3F4F6'
        />
        <path
          d='M90.8619 112.61C90.8619 109.683 92.6056 107.159 95.1217 105.995C94.1715 105.556 93.1118 105.309 91.9935 105.309C87.9133 105.309 84.6055 108.578 84.6055 112.61C84.6055 116.642 87.913 119.911 91.9935 119.911C93.1118 119.911 94.1715 119.664 95.1217 119.224C92.6056 118.06 90.8619 115.537 90.8619 112.61Z'
          fill='white'
        />
        <path
          d='M51.7591 119.911C55.8394 119.911 59.1472 116.642 59.1472 112.61C59.1472 108.577 55.8394 105.309 51.7591 105.309C47.6788 105.309 44.3711 108.577 44.3711 112.61C44.3711 116.642 47.6788 119.911 51.7591 119.911Z'
          fill='#F3F4F6'
        />
        <path
          d='M50.6275 112.61C50.6275 109.683 52.3712 107.159 54.8873 105.995C53.9371 105.556 52.8775 105.309 51.7591 105.309C47.6789 105.309 44.3711 108.578 44.3711 112.61C44.3711 116.642 47.6789 119.911 51.7591 119.911C52.8775 119.911 53.9371 119.664 54.8873 119.224C52.3712 118.06 50.6275 115.537 50.6275 112.61Z'
          fill='white'
        />
        <path
          d='M31.5599 94.9236L40.0984 89.1523H105.301C109.596 89.1523 113.137 85.5893 113.137 81.3086V47.2503C113.137 43.4013 110.344 40.1758 106.529 39.5804L101.334 38.7718L92.0574 9.53452C91.7216 8.47588 90.6132 7.86562 89.5381 8.14742L69.4175 13.4169L65.623 1.45202C65.2716 0.343591 64.0315 -0.273447 62.934 0.1181L35.4168 9.92972C34.3745 10.3012 33.8039 11.4221 34.1167 12.4836L38.9983 29.049L27.7222 27.29L24.1057 13.2597C23.8687 12.3379 23.0377 11.7295 22.0859 11.7295H2.08547C0.933769 11.7295 0 12.663 0 13.8149C0 14.9669 0.933769 15.9004 2.08547 15.9004H20.4689L37.1018 86.0846L29.213 91.4445C22.1975 96.2194 25.7889 107.4 34.1902 107.4H43.8898C42.8796 108.965 42.2863 110.685 42.2863 112.613C42.2863 117.789 46.536 122 51.7598 122C56.9834 122 61.2331 117.789 61.2331 112.613C61.2331 110.685 60.6397 108.964 59.6296 107.4H84.126C83.1159 108.964 82.5221 110.685 82.5221 112.613C82.5221 117.789 86.7717 122 91.9953 122C97.2191 122 101.469 117.788 101.469 112.613C101.469 110.684 100.875 108.964 99.8648 107.4H111.005C112.157 107.4 113.09 106.466 113.09 105.314C113.09 104.162 112.157 103.229 111.005 103.229H34.1902C29.7889 103.229 27.8647 97.4389 31.5599 94.9236ZM55.5131 84.9816L42.3614 33.8558L55.4042 35.8701L68.0322 84.9816H55.5131ZM72.3392 84.9816L59.8913 36.5906L73.2313 38.6513L85.1438 84.9816H72.3392ZM89.4505 84.9816L77.7182 39.3716L91.0581 41.4323L102.255 84.9816H89.4505ZM105.892 43.7018C107.663 43.9781 108.966 45.4706 108.966 47.2505V81.3091C108.966 82.8696 107.934 84.1967 106.531 84.6915L95.5565 42.0924L105.892 43.7018ZM88.6747 12.6844L96.7186 38.0536L68.7058 33.6835L64.392 19.0445L88.6747 12.6844ZM38.6748 13.1961L62.2992 4.77235L65.3758 14.475L61.2555 15.5542C60.1343 15.8478 59.4552 17.0474 59.7834 18.1611L64.148 32.9723L43.5558 29.7599L38.6748 13.1961ZM28.773 31.7359L37.8745 33.1353L51.2064 84.9816H41.1132L28.773 31.7359ZM51.7598 117.829C48.836 117.829 46.4572 115.49 46.4572 112.614C46.4572 109.738 48.836 107.398 51.7598 107.398C54.6836 107.398 57.0621 109.738 57.0621 112.614C57.0621 115.489 54.6836 117.829 51.7598 117.829ZM91.9953 117.829C89.0715 117.829 86.693 115.49 86.693 112.614C86.693 109.738 89.0717 107.398 91.9953 107.398C94.9189 107.398 97.2979 109.738 97.2979 112.614C97.2979 115.489 94.9191 117.829 91.9953 117.829Z'
          fill='#333333'
        />
        <path
          d='M111.562 10.0984C110.41 10.0984 109.477 9.16461 109.477 8.0129V4.87453C109.477 3.72257 110.41 2.78906 111.562 2.78906C112.714 2.78906 113.648 3.72283 113.648 4.87453V8.0129C113.648 9.16461 112.714 10.0984 111.562 10.0984Z'
          fill='#333333'
        />
        <path
          d='M111.562 23.6453C110.41 23.6453 109.477 22.7115 109.477 21.5598V18.4214C109.477 17.2694 110.41 16.3359 111.562 16.3359C112.714 16.3359 113.648 17.2697 113.648 18.4214V21.5598C113.648 22.7115 112.714 23.6453 111.562 23.6453Z'
          fill='#333333'
        />
        <path
          d='M119.915 15.3038H116.773C115.621 15.3038 114.688 14.37 114.688 13.2183C114.688 12.0666 115.621 11.1328 116.773 11.1328H119.915C121.067 11.1328 122 12.0666 122 13.2183C122 14.37 121.067 15.3038 119.915 15.3038Z'
          fill='#333333'
        />
        <path
          d='M106.352 15.3038H103.21C102.059 15.3038 101.125 14.37 101.125 13.2183C101.125 12.0666 102.059 11.1328 103.21 11.1328H106.352C107.504 11.1328 108.438 12.0666 108.438 13.2183C108.438 14.37 107.504 15.3038 106.352 15.3038Z'
          fill='#333333'
        />
        <path
          d='M13.9488 70.5788C12.7971 70.5788 11.8633 69.6451 11.8633 68.4934V65.355C11.8633 64.203 12.7971 63.2695 13.9488 63.2695C15.1005 63.2695 16.0342 64.2033 16.0342 65.355V68.4934C16.0342 69.6453 15.1005 70.5788 13.9488 70.5788Z'
          fill='#333333'
        />
        <path
          d='M13.9488 84.1257C12.7971 84.1257 11.8633 83.1919 11.8633 82.0402V78.9019C11.8633 77.7499 12.7971 76.8164 13.9488 76.8164C15.1005 76.8164 16.0342 77.7502 16.0342 78.9019V82.0402C16.0342 83.1922 15.1005 84.1257 13.9488 84.1257Z'
          fill='#333333'
        />
        <path
          d='M22.3015 75.7842H19.1597C18.008 75.7842 17.0742 74.8505 17.0742 73.6988C17.0742 72.5471 18.008 71.6133 19.1597 71.6133H22.3015C23.4532 71.6133 24.3869 72.5471 24.3869 73.6988C24.3869 74.8505 23.4534 75.7842 22.3015 75.7842Z'
          fill='#333333'
        />
        <path
          d='M8.73921 75.7842H5.59719C4.44549 75.7842 3.51172 74.8505 3.51172 73.6988C3.51172 72.5471 4.44549 71.6133 5.59719 71.6133H8.73921C9.89091 71.6133 10.8247 72.5471 10.8247 73.6988C10.8247 74.8505 9.89091 75.7842 8.73921 75.7842Z'
          fill='#333333'
        />
      </g>
      <defs>
        <clipPath id='clip0_28268_102637'>
          <rect width='122' height='122' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
